import React from 'react';
import { Column } from './styles';
import Status from './Status';
import MotorSettings from './MotorSettings';
import BatteryEpoch from './BatteryEpoch';
import BatteryDanTech from './BatteryDanTech';
import Motor from './Motor';
import PicoState from './PicoState';
import PiJuice from './PiJuice';
import Ina from './Ina';
import Loadcell from './Loadcell';
import Environment from './Environment';
import WaterLevel from './WaterLevel';
import Temperature from './Temperature';
import GPS from './GPS';
import ODrive from './ODrive';
import IMU from './IMU';

export default function LiveData({ messages, isOnline, calibration }) {
  if (!messages) return null;

  return (
    <div>
      {isOnline && <Status data={messages.status} />}

      <Column>
        <MotorSettings
          timestamp={messages.status?.status?.timestamp}
          data={messages.status?.status?.motor_settings}
        />

        <BatteryEpoch data={messages.battery_epoch} />

        <BatteryDanTech data={messages.battery_dantech} />

        <Motor data={messages.motor_gem} />

        <PicoState data={messages.pico_state} />

        <PiJuice data={messages.pijuice} />

        <Ina data={messages.ina} />

        <Loadcell data={messages.loadcell} calibration={calibration} />

        <Environment data={messages.environment} />

        <WaterLevel data={messages.water_level} />

        <Temperature data={messages.temperature} />

        <GPS data={messages.gps} />

        <ODrive data={messages.odrive} />

        <IMU data={messages.imu} />
      </Column>
    </div>
  );
}
